import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { reportRangeSearchSchema, ReportsLayout } from '@/features/reports';

/** Layout of the reports tabs; the range search lives here so every tab shares it. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/reports')({
  staticData: { crumb: 'common:nav.reports' },
  validateSearch: reportRangeSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'reports.read');
  },
  component: ReportsLayout,
});
